import React, {useEffect, useRef, useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import corporationService from "../../../services/web/corporation-service.js";
import {Template} from "../../../components/template/template.jsx";
import {APIProvider, ControlPosition, Map as MapGoogle} from "@vis.gl/react-google-maps";
import AnalysisToolInit from "./analysis-tool-init.jsx";
import bosService from "../../../services/web/bos-service.js";
import Button from "../../../components/button/button.jsx";
import {FaPrint} from "react-icons/fa";
import HeaderTemplateButton from "../../../components/button/header-template-button.jsx";
import Print from "./components/print.jsx";
import analysisToolService from "../../../services/web/analysis-tool-service.js";
import "../gis/css/gis.css"

const mapLayers = new Map();
const mapMarkers = new Map();

const AnalysisToolIndex = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [headerSelected, setHeaderSelected] = useState(-1);
    const [showModalPrint, setShowModalPrint] = useState(false)
    const [filtersToPrint, setFiltersToPrint] = useState([]);
    const [markerTarget, setMarkerTarget] = useState();
    const [isPrinting, setIsPrinting] = useState(false)

    const mapRef = useRef(null);
    const itemsByLayers = useRef(null);
    const itemsByPeriod = useRef(null);
    const subtitles = useRef(null);

    const {data: corporation, isSuccess} = useQuery({
        queryFn: () => corporationService.entity(),
        queryKey: ["corporation"]
    });

    const { data: boName} = useQuery({
        queryFn: () =>  bosService.getBoName(),
        queryKey: ['boName']
    });

    const { data: configs} = useQuery({
        queryFn: () =>  analysisToolService.analysisConfig(),
        queryKey: ['analysis-config'],
        initialData: {}
    });

    const latitude = parseFloat(corporation?.latitude) || 0;
    const longitude = parseFloat(corporation?.longitude) || 0;

    const position = {
        lat: latitude,
        lng: longitude
    }

    return (
        <>
            <Template isLoading={isLoading} className={"print:hidden"}>
                <Template.Header>
                    <Template.Title>Análise georreferenciada</Template.Title>
                    <div className={"flex gap-2"}>
                        <Button title="Imprimir" onClick={() => setShowModalPrint(true)}>
                            <FaPrint/>
                        </Button>

                        <HeaderTemplateButton selected={headerSelected} setSelected={setHeaderSelected} />
                    </div>
                </Template.Header>
                <Template.Body className={`!p-0`}>
                    {
                        !isSuccess &&
                        <div className="animate-pulse h-full">
                            <div className="h-full bg-gray-200"></div>
                        </div>
                    }

                    {
                        isSuccess &&
                        <div className={"h-[calc(100vh-53px)]"} ref={mapRef}>
                            <APIProvider apiKey={corporation?.maps_api_key ?? ""}>
                                <MapGoogle
                                    styles={[
                                        {
                                            "elementType": 'labels', "stylers": [
                                                {
                                                    "visibility": 'off'
                                                }
                                            ]
                                        },
                                        {
                                            "featureType": "poi",
                                            "elementType": "all",
                                            "stylers": [
                                                {
                                                    "visibility": 'off'
                                                }
                                            ]
                                        },

                                        {
                                            "featureType": "road",
                                            "elementType": "labels.text.fill",
                                            "stylers": [
                                                {
                                                    "visibility": 'off'
                                                }
                                            ]
                                        },
                                    ]}
                                    zoomControl={true}
                                    defaultZoom={12}
                                    streetViewControl={true}
                                    fullscreenControl={false}
                                    defaultCenter={position}
                                    gestureHandling={'greedy'}
                                    style={{height: "100%", width: "100%"}}
                                    mapTypeControlOptions={{position: ControlPosition.TOP_RIGHT}}
                                >
                                    <AnalysisToolInit
                                        hasDispatch={configs?.has_dispatch}
                                        hasWaze={configs?.has_waze}
                                        setIsLoading={setIsLoading}
                                        boName={boName}
                                        setFiltersToPrint={setFiltersToPrint}
                                        subtitles={subtitles}
                                        itemsByLayers={itemsByLayers}
                                        itemsByPeriod={itemsByPeriod}
                                        filtersToPrint={filtersToPrint}
                                        mapMarkers={mapMarkers}
                                        mapLayers={mapLayers}
                                        markerTarget={markerTarget}
                                        setMarkerTarget={setMarkerTarget}
                                        isPrinting={isPrinting}
                                    />
                                </MapGoogle>
                            </APIProvider>
                        </div>
                    }
                </Template.Body>
            </Template>

            <Print
                itemsByPeriod={itemsByPeriod.current}
                itemsByLayers={itemsByLayers.current}
                subtitles={subtitles.current}
                filters={filtersToPrint}
                layers={mapLayers}
                markers={mapMarkers}
                markerTarget={markerTarget}
                showModalPrint={showModalPrint}
                setShowModalPrint={setShowModalPrint}
                mapRef={mapRef}
                headerSelected={headerSelected}
                setIsPrinting={setIsPrinting}
                setIsLoading={setIsLoading}
                isPrinting={isPrinting}
            />
        </>
    );
};

export default AnalysisToolIndex;
